import React from 'react'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
import {
  i18nTranslate,
  trackEnhancedCartEvent,
  getLiveEventStatus,
} from 'src/utils'
import { Row, Col, Container, Modal, Button } from 'react-bootstrap'
import isEmpty from 'lodash/isEmpty'
import { IS_BROWSER, getLocalStorage, enablePdpRedesign } from 'src/utils'
import {
  ProductImageWithFavorites,
  ProductDetail,
  ProductDetailSection,
  ProductContext,
  ProductComponent,
  RecommendedProducts,
} from 'src/views/components'
import { PDPContext } from 'src/views/components/BaseProductComponent'
import { productState } from 'src/views/components/BaseProductComponent/ProductState'
import {
  ProductShipping,
  ProductRefundPolicy,
  ProductIngredients,
  ProductInfobar,
  ProductBenefitsandFeatures,
  ProductProvenResults,
  ProductHowtoUseit,
  Productfaq,
  ProductDetailsDropdown,
  ProductDisclaimers,
  ProductSustainability,
  ProductResources,
  // ProductDisclaimerWarnings,
} from 'src/views/components/ProductComponents'
import {
  storeContainer,
  nuskinSubscriptionContainer,
  cartContainer,
  customerContainer,
  promotionContainer,
} from 'src/models'
import { productDeps } from 'src/deps'
import { APPConfig } from 'config/appConfig'
import { Link } from 'react-router-dom'

@observer
class Product extends ProductComponent {
  @observable showCustomerModal = true
  enableLiveEvent = getLiveEventStatus()
  isEventRegisteredUser = ''
  constructor(props, context) {
    super(props, context)
    // this.state = {
    //   show: true,
    // }
  }

  componentDidUpdate(prevProps) {
    // Calls get product only if pathname is changed
    // Query param change is ignored
    const isPathChanged =
      JSON.stringify(prevProps?.location?.pathname) !==
      JSON.stringify(this.props?.location?.pathname)

    /**
     * isVariantChangedFromMiniCart is a edge case
     * https://nuskin.atlassian.net/browse/CX16-10051
     *
     * consider we are in pdp which has variants
     * and we are in mini cart and we click on the same pdp url with different variant
     * if variant is changed from mini cart, then we need to call getProduct
     *
     * this is a temporary fix, we are unable to handle variant click when url is changed from mini cart
     * hence making the API for the Edge case
     */
    const isVariantChangedFromMiniCart =
      JSON.stringify(prevProps?.location?.search) !==
        JSON.stringify(this.props?.location?.search) &&
      cartContainer.isCartVisible

    if (isPathChanged || isVariantChangedFromMiniCart) {
      promotionContainer.resetV2PromoResponse()
      productState.getProduct(this.props)
    }
  }

  handleClose() {
    this.showCustomerModal = false
    // this.setState({ show: true })
  }

  isJsonObject = strData => {
    try {
      JSON.parse(strData)
    } catch (e) {
      return false
    }
    return true
  }
  checkEventRegisteredUser() {
    const profileResponse = customerContainer?.profileResponse
    const accountProperties = profileResponse?.accounts?.properties || []
    const userProperty = accountProperties?.filter(
      property => property?.attributeId === 'registeredEvent'
    )
    return userProperty?.[0]?.value || 'false'
  }

  renderProductView = (
    productResponse = {},
    product = {},
    productCount = 1,
    inventory = {},
    subscribeAndSave = 0
  ) => {
    this.isEventRegisteredUser = this.checkEventRegisteredUser()
    if (IS_BROWSER) {
      const productStatus = document.getElementById('qa-product-availability')
      const text = productStatus?.textContent
      productStatus?.setAttribute('role', 'alert')
      productStatus?.setAttribute('aria-label', text)
    }
    // @##pdp_scancard
    const scanCount = productResponse?.product?.properties?.scanQualifiedCount
    const enableNewPDPStyle =
      APPConfig?.getAppConfig()?.enableNewPDPStyle === 'true'
    if (productResponse?.product) {
      const {
        isCollection = false,
        isBundle = false,
        categoryId = '',
      } = product
      const activeStoreResponse = storeContainer.activeStoreResponse
      let currentAccountType = getLocalStorage('accountType')
      let customerConfigs = []
      let customerName = ''
      let customerConfigObj = ''
      activeStoreResponse?.properties?.find(data => {
        try {
          if (data.name === 'customerTypeAssociationConfig') {
            customerConfigs = JSON.parse(data?.value || '{}')
          }
        } catch (e) {
          console.log('JSON.parse() >>> error ', e)
        }
      })

      const customerAssociationConfig = activeStoreResponse?.properties?.filter(
        data => data.name === 'customerTypeAssociationConfig'
      )
      try {
        if (customerAssociationConfig) {
          customerConfigs = JSON.parse(customerAssociationConfig.value)
        }
      } catch (e) {}
      customerConfigObj = !isEmpty(customerConfigs)
        ? customerConfigs?.config[currentAccountType]
        : {}

      customerName = customerConfigObj?.hasOwnProperty('name')
        ? customerConfigObj?.name?.toLowerCase()
        : 'NotFound'
      let allowedCustomerType = product.customerTypes?.toLowerCase()
      const { location = '', history = '', match = '' } = this.props
      const isProductEligible =
        currentAccountType?.includes('Brand Affiliate') ||
        currentAccountType == null ||
        allowedCustomerType?.includes(customerName) ||
        customerName === 'NotFound'
      const enableProductDetails = enableNewPDPStyle ? !isBundle : true

      if (this.enableLiveEvent === 'true') {
        const productData = {
          band: product?.brand,
          categoryId: product?.categoryId,
          currency: product?.currency,
          productName: product?.name,
          quantity: '',
          skuId: product?.skuId,
          totalPrice: product?.totalValue?.priceAfterDiscount,
          variantLabel: product?.variantLabel,
        }
        if (
          customerContainer.isRegisterUser &&
          this.isEventRegisteredUser === 'false'
        ) {
          trackEnhancedCartEvent({
            type: 'view_not_register_alert',
            item: productData,
            price: product?.totalValue?.priceAfterDiscount,
          })
        }
        trackEnhancedCartEvent({
          type: 'view_item',
          item: productData,
          price: product?.totalValue?.priceAfterDiscount,
        })

        // view_promotion event is disabled as July Live Event is not having promotions
        // if (product?.promotion?.length > 0) {
        //   trackProductClickEvent({
        //     type: 'view_promotion',
        //     action: { list: 'Search Results' },
        //     categoryId: product?.categoryId,
        //     product,
        //     promotionClass: product?.promotion?.[0]?.promotionClass,
        //     offerId: product?.promotion?.[0]?.offerId,
        //     promotion: true,
        //   })
        // }
      }
      const isPbomProduct = productDeps.isPbomProduct(product)
      return (
        <section data-testid="qa-product-details-wrapper">
          {!isProductEligible && (
            <div className="customer-modal">
              <Modal
                centered={true}
                size={'md'}
                className={`modal-wrapper customertype-modal p-0`}
                show={this.showCustomerModal}
                onHide={this.handleClose}
                style={{
                  overlay: {
                    backgroundColor: 'rgba(0, 0, 0, 0.3)',
                  },
                }}
                dialogClassName="customertype-dialog">
                <Modal.Body>
                  <Modal.Header className={'border-bottom-0'} />
                  <div className="customertype-content">
                    <p className="paragraph-l pt-4 pb-2">
                      {i18nTranslate(
                        'pdp.eligible',
                        'You are not eligible to purchase this product',
                        {
                          nameSpace: 'ssr-resource',
                        }
                      )}
                    </p>
                    <Link to="/">
                      <Button
                        variant="primary"
                        className="btn-addToCart border-0 w-100 text-uppercase rounded-0 d-flex justify-content-center align-items-center align-content-center">
                        {i18nTranslate('pdp.homePage', 'Go To Homepage', {
                          nameSpace: 'ssr-resource',
                        })}
                      </Button>
                    </Link>
                  </div>
                </Modal.Body>
              </Modal>
            </div>
          )}
          {/* {application.isMobile && this.renderTitle()} */}
          <div
            className={`pdp-page container py-3 ${enablePdpRedesign() ? 'pdp-redesign' : ''}`}>
            <Row className="position-relative">
              <Col sm={12} md={12} lg={6} className="mb-2">
                <ProductImageWithFavorites
                  product={product}
                  categoryId={categoryId}
                  location={location}
                  history={history}
                  isFromPDP={true}
                />
              </Col>
              <Col sm={12} md={12} lg={6}>
                <PDPContext.Provider
                  value={{
                    isPDP: true,
                  }}>
                  <ProductDetail
                    handleSkuSelection={this.handleSkuSelection}
                    handleQuantityChange={this.handleQuantityChange}
                    handleQuantityChangePromotion={
                      productState?.handleQuantityChangePromotion
                    }
                    product={product}
                    selectSkuById={this.selectSkuById}
                    scanCount={scanCount}
                    productCount={productCount}
                    handleAddToBag={this.handleAddToBag}
                    categoryId={categoryId}
                    inventory={inventory}
                    subscribeAndSave={subscribeAndSave}
                    isSubscribeBtnDisabled={
                      nuskinSubscriptionContainer.displaySubscribeAndSavePrice
                    }
                    {...this.props}
                    renderBundlePriceAndButtons={
                      this.renderBundlePriceAndButtons
                    }
                  />
                </PDPContext.Provider>
                {(isPbomProduct || (!isBundle && !isCollection)) &&
                  (!enableNewPDPStyle ? (
                    <>
                      {product.shipping && this.enableLiveEvent !== 'true' && (
                        <ProductShipping product={product} />
                      )}
                      {product.refund && (
                        <ProductRefundPolicy product={product} />
                      )}
                      <ProductDetailSection {...product} />
                    </>
                  ) : (
                    <>
                      <ProductDetailSection {...product} />
                      {product.shipping && this.enableLiveEvent !== 'true' && (
                        <ProductShipping product={product} />
                      )}
                      {product.refund && (
                        <ProductRefundPolicy product={product} />
                      )}
                    </>
                  ))}
              </Col>
            </Row>
          </div>
          {product.features && <ProductInfobar product={product} />}
          <div className="bundle-products">
            <Container fluid>
              {!enableNewPDPStyle && isBundle && (
                <div className="mt-3">{this.renderBundleData()}</div>
              )}
              {isCollection && this.renderCollection()}
              {/* <CrossSellUpSell {...productResponse} /> */}
              <ProductContext.Provider
                value={{
                  location: location,
                  history: history,
                  match: match,
                  name: product.name,
                }}></ProductContext.Provider>
            </Container>
          </div>
          <div className="pdp-bottom-section-wrapper">
            {/* new pdp design product details section location changed for bundle and kits */}
            {enableProductDetails &&
              (product.productDetails || product.productDetailsDescription) && (
                <ProductDetailsDropdown product={product} />
              )}
            {/* Product similar carousel - crossSellProducts or from AWS recommended products */}
            <RecommendedProducts product={product} />
            {/* {product.crossSellProducts?.length > 0 && (
              <ProductSimilar product={product} />
            )} */}
            {product.benefits && (
              <ProductBenefitsandFeatures product={product} />
            )}
            {product.usage && this.isJsonObject(product.usage) && (
              <ProductHowtoUseit product={product} />
            )}
            {product.ingredients && <ProductIngredients product={product} />}
            <ProductSustainability product={product} />
            {product.results && <ProductProvenResults product={product} />}
            {product.resources && <ProductResources product={product} />}
            {product.faqs && <Productfaq product={product} />}
            {(product?.disclaimers || product?.disclaimerWarnings) && (
              <ProductDisclaimers product={product} />
            )}
            {/* {product.disclaimerWarnings && (
              <ProductDisclaimerWarnings product={product} />
            )} */}
          </div>
        </section>
      )
    }

    return ''
  }
}

export { Product }

// export default Product
export default Product
